import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear(); 
  return (
    <Box sx={{ p: 3, textAlign: "center" }}>
  
      <Typography>
            Version 2.0  © {currentYear} All rights reserved by S.S. White Technologies India  PVT LTD.
      </Typography>
    </Box>
  );
};

export default Footer;
